import AppService from './AppService';
import { iKeyValuePairs } from '../shared/UITypes/types';

const getCouriers = (config?: iKeyValuePairs) => {
  return AppService.get('/courier', {
    include: 'createdBy,updatedBy',
    ...config,
  }).then(({ data }) => data);
};

const deactivateCourier = (id: string) => {
  return AppService.delete(`/courier/${id}`).then(({ data }) => data);
};

const createCourier = (postData: iKeyValuePairs) => {
  return AppService.post('/courier', postData).then(({ data }) => data);
};

const updateCourier = (id: string, updateContent: iKeyValuePairs) => {
  return AppService.put(`/courier/${id}`, updateContent).then(({ data }) => data);
};

export default {
  getCouriers,
  deactivateCourier,
  createCourier,
  updateCourier,
};
